import { render, staticRenderFns } from "./Photography.vue?vue&type=template&id=d1e44e4a&scoped=true"
import script from "./Photography.vue?vue&type=script&lang=js"
export * from "./Photography.vue?vue&type=script&lang=js"
import style0 from "./Photography.vue?vue&type=style&index=0&id=d1e44e4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1e44e4a",
  null
  
)

export default component.exports